<template>
  <div class="success container_padding">
    <div class="success-box">
      <img src="../../assets/web/success.png" alt />
      <span>{{$t('message.submit_success')}}</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.success-box {
  background: #fff;
  height: 100%;
  min-height: 750px;
  height: 500px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #8cbb19;
}
</style>